{
  "loading": "Зареждане...",
  "loadingMore": "Зареждане на още..."
}